$(document).ready(function(){
  // cartHiddenSlug();
  
 
  $("[data-add-to-cart]").on("click",function(e){
    if($(this).hasClass("firstclick")){
      e.preventDefault();
      $(".unclicked").removeClass("unclicked");
      $(".firstclick").removeClass("firstclick");
    }
  })

  

  // If on pdp, set click event listener on the review stars that scrolls down to the reviews section
  if(window.location.pathname.includes('/products/')) {
    $('.product-detail__review').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('#product__testimonial').offset().top
      }, 500)
    })
  }



  setTimeout(function(){ //console.log("In Loop ");

    $(".yotpo.bottomLine").each(function(){ //console.log("In Loop ");

      //console.log("review : "+ $(this).has(".yotpo-bottomline").length);
      if(!$(this).has(".yotpo-bottomline").length){
        $(this).html('<div class="yotpo-bottomline pull-left  star-clickable"><span class="yotpo-stars"><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span> </span>      <div class="yotpo-clr"></div> </div>');
      }


    })


  },1000)



  // Add smooth scrolling to all links
  $(".fac-link").on('click', function(event) {

      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });

  });




  //$(".close-form").on("click",function(){ check_addtocart();})


  $("#report-table-header button[column=origin]").click(function(){
    $("#report-table-header button[column=description]").removeClass("active");
    $(this).addClass("active");
    $("#report").removeClass("description");
    $("#report").addClass("origin");
  });
  $("#report-table-header button[column=description]").click(function(){
    $("#report-table-header button[column=origin]").removeClass("active");
    $(this).addClass("active");
    $("#report").removeClass("origin");
    $("#report").addClass("description");
  });


  //setTimeout(function(){ $('#stickyquantity-product-template').val($('#quantity-product-template').val()); }, 2000);

  $('body').on("click", ".qtybox .btnqty", function(){
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);

    //$('#quantity-product-template').val(qty);
    const input = $(this).parent('.qtybox').find('.quantity-input');
    const id = input.attr("id");
    if(id.startsWith('sticky')){
      const mainID =  id.replace('sticky','');
      $(`#${mainID}`).val(qty);
    }else {
      const stickyID = 'sticky' + id;
      $(`#${stickyID}`).val(qty);
    }
  });

  // $(document).on("click", ".slide-remove-item", function(event){
  //   event.preventDefault();

  //   $('.loader-cover').removeClass('hide');
  //   var productId = parseInt($(this).attr('data-id'));
  //   $.post('/cart/update.js', 'updates['+productId+']=0')
  //   .done(function() { console.log("success"); })
  //   .fail(function() { console.log("error"); })
  //   .always(function() { console.log("complete");
  //     $('#cover_'+productId).remove();

	//   //console.log('ProductId: '+productId);


  //     $.getJSON('/cart.js', function(cart) {
  //       $('#CartCount span[data-cart-count]').text(cart.item_count);
  //       $('.cart-subtotal-wrap span[data-cart-subtotal]').text(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat) + ' USD');
  //       if(cart.item_count < 1){
  //         $('.cart_drawer__process').addClass('hide');
  //         $('.cart_drawer__items').html('');
  //         $('.cart-popup-items-wrap').append('<div class="empty_cart_popup_cover"><h4 class="empty-cart-title">No items in your BAG</h4><div class="empty-cart-box-wrap"><div class="empty-cart-box"><div class="empty-cart-box-left"><h5 class="empty-box-title">Can’t decide? Start with the Sampler Pack.</h5><a href="/collections/all" class="btn view-btn">VIEW</a></div><div class="empty-box-right"><div class="empty-box-image-wrap"><img src="//cdn.shopify.com/s/files/1/1652/1243/files/bowls-topdown-ensemble-new.png" alt="Four Dish"/></div></div></div></div><div class="empty-footer-image"><img src="//cdn.shopify.com/s/files/1/1652/1243/t/50/assets/dog-4.png" alt="Empty Cart Dog"/></div></div>');
  //         $('.cart_drawer__items').append('<div class="cart_drawer__empty"><p>There are no items in your bag.</p></div>');
  //         $('.cart_drawer__footer').addClass('hide');
  //         $('.subscription__cover').addClass('hide');

  //         setTimeout(function(){ $('.loader-cover').addClass('hide'); }, 3000);
  //       }

  //       cartDrawerProcess(cart, cart.item_count);

  //       $.each(cart.items, function(index, cartItem) {
  //         //console.log('cartItem_id:  '+cartItem.handle);
  //         var addedSlug = cartItem.handle;
  //         //$('#slug-'+addedSlug).attr('data-hidden', 'false');
  //       });

  //       cartHiddenSlug(cart, cart.item_count);

  //       cartPriceUpdate();

  //     });



  //   });
  // });


  $(document).on("click", ".cart-quantity .cartbtnqty", function(){

    $('.loader-cover').removeClass('hide');

    var current_itemid = $(this).data('itemid');
    var current_itemkey = $(this).data('itemkey')
    var current_itemprice = $(this).data('itemprice')
    var price_selector = $('[data-itemid="'+current_itemid+'"] span[data-cart-item-regular-price]').text(theme.Currency.formatMoney(current_itemprice*qty, theme.moneyFormat));
    var qty = parseInt($(this).parent('.cart-quantity').find('.quantity-input-'+current_itemid).val());

    if($(this).hasClass('qtyplus')) {
      qty++;

      $('.cart_drawer__items [data-addedfirstvid="'+current_itemid+'"]').attr('data-addedqty',qty);
      price_selector.text(theme.Currency.formatMoney(current_itemprice*qty, theme.moneyFormat));
      var finalQTY = qty;
      var finalVID = current_itemid;
      var finalkey = current_itemkey;
      var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity='+finalQTY+'&id='+finalkey,
        dataType: 'json',
        success: function(cart) {
          $('#CartCount span[data-cart-count]').text(cart.item_count);
          var CartTotalPrice = theme.Currency.formatMoney(cart.total_price, theme.moneyFormat);
          $('.subtotal-price-wrap').text(CartTotalPrice + ' USD');
          $.each(cart.items, function(index, cartItem) {        /*console.log(cartItem);*/       });

          $.getJSON('/cart.js').then(function(cart) {
           // console.log('successfully got cart data', cart)
            var cartUpdateEvent = new CustomEvent('cart.update', {'detail': cart});
            document.dispatchEvent(cartUpdateEvent);
            setTimeout(function(){ $('.loader-cover').addClass('hide'); }, 500);
          })
        },
        error: function(XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      };
      $.ajax(params);

    }else { //console.log('else minus');
      if(qty > 1) {
        qty--;

        $('.cart_drawer__items [data-addedfirstvid="'+current_itemid+'"]').attr('data-addedqty',qty);
        price_selector.text(theme.Currency.formatMoney(current_itemprice*qty, theme.moneyFormat));
        var finalQTY = qty;
        var finalVID = current_itemid;
        var finalkey = current_itemkey;
        var params = {
          type: 'POST',
          url: '/cart/change.js',
          data:  'quantity='+finalQTY+'&id='+finalkey,
          dataType: 'json',
          success: function(cart) {

            $('#CartCount span[data-cart-count]').text(cart.item_count);
            var CartTotalPrice = theme.Currency.formatMoney(cart.total_price, theme.moneyFormat);
            $('.subtotal-price-wrap').text(CartTotalPrice + ' USD');

            //console.log(cart.item_count);

            //$.each(cart.items, function(index, cartItem) { /*console.log(cartItem.final_line_price);*/  });

            $.getJSON('/cart.js').then(function(cart) {
              //console.log('successfully got cart data', cart)
              var cartUpdateEvent = new CustomEvent('cart.update', {'detail': cart});
              document.dispatchEvent(cartUpdateEvent);
              setTimeout(function(){ $('.loader-cover').addClass('hide'); }, 500);
            })

          },
          error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
          }
        };
        $.ajax(params);
      }else{

        //console.log('icon QTY zero'+ current_itemid);

        // $('.remove-item-'+current_itemid+' .slide-remove-item').click();

        
        
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: 'quantity=0&id='+current_itemkey,
          dataType: "json",
          success: function() {
            $.getJSON('/cart.js').then(function(cart) {
             // console.log('successfully got cart data', cart)
              var cartUpdateEvent = new CustomEvent('cart.update', {'detail': cart});
              document.dispatchEvent(cartUpdateEvent);
              setTimeout(function(){ $('.loader-cover').addClass('hide'); }, 500);
            })
          }
        })


        // getCartJSON();
        // cartPriceUpdate();
        // setTimeout(function(){ $('.loader-cover').addClass('hide'); }, 2000);

      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.cart-quantity').find('.quantity-input-'+current_itemid).val(qty);
  });


  // function cartDrawerProcess(cart, item_count){

  //   console.log(cart.item_count);

  //     if(cart.item_count == 1){ console.log('loop 1');
  //       $('.progress').html('<span style="width: 33%;"></span>');
  //       $('.cart_drawer__process p:nth-child(1)').text('Add 1 Item to Ship Your Order');
  //       $('.cart_drawer__process p:nth-child(1)').removeClass('hide');
  //       $('.cart_drawer__process p:nth-child(2)').addClass('hide');
	// 	$('#ajax_checkout').addClass('disabled');
	// 	$('.shipping-tag').text('$15.00');
	// 	$('.cart_drawer__process').removeClass('finished');
	// 	$('.cart_drawer__recommended').removeClass('hide');
	//   }else if(cart.item_count == 2){ console.log('loop 2');
  //       $('.progress').html('<span style="width: 66%;"></span>');
  //       $('.cart_drawer__process p:nth-child(1)').html('<a href="javascript:;" class="ajax_checkout_2">Checkout</a> or Add 1 Item for Free Shipping');
  //       $('.cart_drawer__process p:nth-child(1)').removeClass('hide');
  //       $('.cart_drawer__process p:nth-child(2)').addClass('hide');
	// 	$('#ajax_checkout').removeClass('disabled');
	// 	$('.shipping-tag').text('$15.00');
	// 	$('.cart_drawer__process').removeClass('finished');
	// 	$('.cart_drawer__recommended').removeClass('hide');
  //     }else if(cart.item_count >= 3){ console.log('loop 3');
  //       $('.progress').html('<span style="width: 100%;"></span>');
  //       $('.cart_drawer__process p:nth-child(1)').addClass('hide');
  //       $('.cart_drawer__process p:nth-child(2)').removeClass('hide');
	// 	$('#ajax_checkout').removeClass('disabled');
	// 	$('.cart_drawer__process').addClass('finished');
	// 	$('.shipping-tag').text('FREE');
	// 	$('.cart_drawer__recommended').addClass('hide');
  //     }else{ console.log('Else loop');
  //       $('.cart_drawer__process p:nth-child(1)').addClass('hide');
  //       $('.cart_drawer__process p:nth-child(2)').addClass('hide');
  //     }
  // }


  //START : Sticky Bar Sync

  // Sticky to Main dropdown change
  $(".sticky-single-option-selector").on("change",function(){
    var value = $(this).val(); //console.log("sticky value : "+value);
    $(".rtx_option_plans_dropdown").val(value);
    const onetimePriceEl = document.querySelector('.product-form__cart-submit .js-atc-onetime-price')
    const subscriptionPriceEl = document.querySelector('.product-form__cart-submit .js-atc-sub-price')
    const stickyPriceEl = document.querySelector('.sticky-product-form__cart-submit .price-item--regular')
    
    
    
    if (value === 'onetime') {
      document.querySelector('label[for="product_onetime"]').click();
      stickyPriceEl.innerText = onetimePriceEl.innerText;
    } else {
      document.querySelector('label[for="product_subsave-1"]').click();
       // Event a change event for the buybox subscription select
       const changeEvent = new Event('change');
       document.querySelector(".rtx_option_plans_dropdown").dispatchEvent(changeEvent);
       stickyPriceEl.innerText = subscriptionPriceEl.innerText;
    }
  })

  //Main dropdown to  Sticky change
  $(".rtx_option_plans_dropdown").on("change",function(){
    var value = $(this).val(); //console.log("sticky value : "+value);
    $(".sticky-single-option-selector").val(value)
    
    const onetimePriceEl = document.querySelector('.product-form__cart-submit .js-atc-onetime-price')
    const subscriptionPriceEl = document.querySelector('.product-form__cart-submit .js-atc-sub-price')
    const stickyPriceEl = document.querySelector('.sticky-product-form__cart-submit .price-item--regular')
    if (value === 'onetime') {
      if (onetimePriceEl && stickyPriceEl) {
        stickyPriceEl.innerText = onetimePriceEl.innerText;
      }
    } else {
      if (subscriptionPriceEl && stickyPriceEl) {
        stickyPriceEl.innerText = subscriptionPriceEl.innerText;
      }
    }
  })

  

  //Main subscription to Sticky dropdown  change
  $("input[name='purchase_option']").on("change",function(){
    var v = $(this).val();

    if(v == "onetime"){
      var v = $("select[data-smartrr-selling-plans-select]").val();
    	$(".sticky-single-option-selector").val(v);
    }else{
      	var f = $("select[data-smartrr-selling-plans-select]").val();
    	$(".sticky-single-option-selector").val(f);
    }
    setTimeout(function(){
      var price = $("span[data-smartrr-subscribe-price]").text();
      $(".product__price_sticky .price-item--regular").text(price);
    },200);

  })

  //Main subscription freuancy to Sticky dropdown  change
  $("select[data-smartrr-selling-plans-select]").on("change",function(){
    var v = $(this).val();
    $(".sticky-single-option-selector").val(v);
  })

  // Sticky Add to cart trigger
  $(".sticky-product-form__cart-submit").on("click",function(){
  	$("[data-add-to-cart]").trigger("click");
  })

  const stickyDropdown = document.querySelector('.sticky-single-option-selector');
  // Handle one-time purchase option select and set sticky dropdown to onetime
  const onetimeButton = document.querySelector('label[for="product_onetime"]')
  if (onetimeButton && stickyDropdown) {
    onetimeButton.addEventListener('click', (e) => {
      stickyDropdown.value = 'onetime'
      const onetimePriceEl = document.querySelector('.product-form__cart-submit .js-atc-onetime-price')
      const stickyPriceEl = document.querySelector('.sticky-product-form__cart-submit .price-item--regular')
      stickyPriceEl.innerText = onetimePriceEl.innerText;
    })
  }
  // Handle subscription purchase option select and set sticky dropdown to selected subscription plan
  const subscriptionButton = document.querySelector('label[for="product_subsave-1"]')
  if (subscriptionButton && stickyDropdown) {
    subscriptionButton.addEventListener('click', (e) => {
      const plansSelectEl = document.querySelector('.rtx_option_plans_dropdown')
      if (plansSelectEl) {
        const value = plansSelectEl.value
        stickyDropdown.value = value
      }
      const subscriptionPriceEl = document.querySelector('.product-form__cart-submit .js-atc-sub-price')
      const stickyPriceEl = document.querySelector('.sticky-product-form__cart-submit .price-item--regular')
      stickyPriceEl.innerText = subscriptionPriceEl.innerText;
    })
  }

  $('.product-form__more button').click(function (){
    $('html, body').animate({
      scrollTop: $("#product__calculator").offset().top - 100
    }, 1000)
  });


  $(window).scroll(function(){
    var h = $('#shopify-section-product-template').height() + 50;
    if ($(this).scrollTop() > h) {
      $('.product-sticky').addClass('stick');
    } else {
      $('.product-sticky').removeClass('stick');
    }
  });

  $('.product_menu a').click(function (){
    $('html, body').animate({
      scrollTop: $( $(this).attr('href') ).offset().top - 150
    }, 1000);
     return false;
  });

  $(window).scroll(function(){
    if ($(this).scrollTop() > 150) {
      $('.product_menu').addClass('stick');
    } else {
      $('.product_menu').removeClass('stick');
    }
  });


  // $(".site-header__cart").click(function(){
  // 	$("body").addClass("cart-drawer-open");
  //   $('.cart_drawer').addClass('cart_open');
  //   $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
  // });
  $(".product-form__cart-submit").click(function(){
  	//$("body").addClass("cart-drawer-open");
  });
  // $(document).on("click", ".cart_drawer__close", function(){
  //   $("body").removeClass("cart-drawer-open");
  //   $('.cart_drawer').removeClass('cart_open');
  //   if($("body").hasClass('cart-drawer-open')) {
  //     $("body").removeClass("cart-drawer-open");
  //     $('.cart_drawer').removeClass('cart_open');
  //   }
  //   $('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');
  // });

  // $(document).on("click", ".cart-popup__close", function(){
  //   $("body").removeClass("cart-drawer-open");
  //   if($("body").hasClass('cart-drawer-open')) {
  //     $("body").removeClass("cart-drawer-open");
  //   }
  //   $('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');
  // });

  // on Chekcout : Check for minimum Qty 3
  /*$("[name='checkout'], #ajax_checkout").on("click",function(e){ console.log("clicked on checkout");

	var recharge = false;
	if($(".week-wrap").length || $(".subscribe").length){
		recharge = true;
	}

	console.log(recharge);


	//var checkout_url = buildCheckoutUrl(ReCharge.cart_options);
    console.log(ReCharge.cart_options);


    var form = $('form#cart');
    e.preventDefault();
  	$.getJSON('/cart.js').then(

    function(cart) { //console.log(cart);

		var isonlysample = true; //console.log("only Sample :" + isonlysample);
		var sample_qty = 0; //console.log("Sample Qty :" + sample_qty);
		var prouct_qty = 0; //console.log("Product Qty :" + prouct_qty);
		var total_qty = cart.item_count; //console.log("Total Qty :" + total_qty);

		$.each(cart.items, function(i, item) { //console.log(item);
          if(!item.handle.includes('sampler-pack')){
			isonlysample = false;
          }else{
          	sample_qty += item.quantity;
          }
        })

        prouct_qty = total_qty - sample_qty;

        //console.log("only Sample :" + isonlysample);
        //console.log("Sample Qty :" + sample_qty);
        //console.log("Product Qty :" + prouct_qty);

		if(isonlysample){ console.log("Go to checkout");
            $(".cart__error-message-wrapper").addClass("hide");
            window.location.href = '/checkout';
        }else{
          if(prouct_qty > 2){ //console.log("Go to checkout");
          	$(".cart__error-message-wrapper").addClass("hide");
         	window.location.href = '/checkout';
          }else{
        	console.log("Throw Error Message");
            $(".cart__error-message").text($(".cart__error-message-wrapper").data("message"));
            $(".cart__error-message-wrapper").removeClass("hide");
            //e.preventDefault;
          }

        }

    }

  );

})*/



  //check_addtocart();


//NEW CART BAG CODE

  

 
  $(document).on("click", ".cart_drawer__recommended .item__add_to_cart button", function(){
    $('.loader-cover').removeClass('hide');
    var variant_id = $(this).data('firstvariantid');
    var qty = '1';
    var selling_plan = $('.selling-plan-allocation').first().text();
    if ($(this).data('product-type') == 'subscription') {
      var data = {
        "id": variant_id,
        "quantity": qty,
        "selling_plan": selling_plan
      }
    } else {
      var data = {
        "id": variant_id,
        "quantity": qty
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(cartitem) {
        $.getJSON('/cart.js').then(
          function(cart) {
            console.log(cart);
        });
        // $('.cart_drawer__empty').remove();
        $('.cart_drawer__process').removeClass('hide');
        
        $.getJSON('/cart.js').then(function(cart) {
          
          var cartUpdateEvent = new CustomEvent('cart.update', {'detail': cart});
          document.dispatchEvent(cartUpdateEvent);
          $('.loader-cover').addClass('hide');
        })
        // getCartJSON();
        // cartPriceUpdate();
      }
    });

  });


  //NEW ALL 3LB ADD CART BAG CODE
 /* $(document).on("click", ".cart_drawer__recommended .all_3lb_items button, .pdp_3lb", function(){
    $('.loader-cover').removeClass('hide');

    var shipping_interval_frequency = $('.shipping_interval_frequency').val();
    console.log('shipping_interval_frequency all_3lb_items: '+shipping_interval_frequency);

    var item_array = [];

    if(shipping_interval_frequency == ''){
      $( ".cart_drawer__recommended .cart_drawer__item.3lb" ).each(function( index ) {
          var item = {}
          var firstVariantID = $(this).find('button').data('firstvariantid');
          console.log(firstVariantID);
          item['id'] = firstVariantID
          item['quantity'] = 1;
          item_array.push(item);
      })
    }else{
      $( ".cart_drawer__recommended .cart_drawer__item.3lb" ).each(function( index ) {
          var item = {}
          var firstVariantID = $(this).find('button').data('firstvariantid');
          console.log(firstVariantID);
          item['id'] = firstVariantID
          item['quantity'] = 1;
          item['properties'] = {"subscription_id": '268814',"shipping_interval_frequency": shipping_interval_frequency,"shipping_interval_unit_type": 'Weeks'};
          item_array.push(item);
      })
    }
    data = {items:item_array}
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(cartitem) {
        $('.cart_drawer__empty').remove();
        $('.cart_drawer__process').removeClass('hide');
        getCartJSON();
        cartPriceUpdate();
        $("body").addClass("cart-drawer-open");
        $('.cart_drawer').addClass('cart_open');
        $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');

      }
    });
  });


  //NEW ALL 7LB ADD CART BAG CODE
  $(document).on("click", ".cart_drawer__recommended .all_7lb_items button, .pdp_7lb", function(){
    $('.loader-cover').removeClass('hide');

    var shipping_interval_frequency = $('.shipping_interval_frequency').val();
    console.log('shipping_interval_frequency all_7lb_items: '+shipping_interval_frequency);

    var item_array = [];

    if(shipping_interval_frequency == ''){
      $( ".cart_drawer__recommended .cart_drawer__item.7lb" ).each(function( index ) {
          var item = {}
          var firstVariantID = $(this).find('button').data('firstvariantid');
          console.log(firstVariantID);
          item['id'] = firstVariantID
          item['quantity'] = 1;
          item_array.push(item);
      })
    }else{
      $( ".cart_drawer__recommended .cart_drawer__item.7lb" ).each(function( index ) {
        var item = {}
        var firstVariantID = $(this).find('button').data('firstvariantid');
        console.log(firstVariantID);
        item['id'] = firstVariantID
        item['quantity'] = 1;
        item['properties'] = {"subscription_id": '268814',"shipping_interval_frequency": shipping_interval_frequency,"shipping_interval_unit_type": 'Weeks'};
        item_array.push(item);
      })
    }
    data = {items:item_array}
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(cartitem) {
        $('.cart_drawer__empty').remove();
        $('.cart_drawer__process').removeClass('hide');
        getCartJSON();
        cartPriceUpdate();
        $("body").addClass("cart-drawer-open");
        $('.cart_drawer').addClass('cart_open');
        $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
      }
    });
  });
  */


  function getCartJSON(){

    cartHiddenSlug();

    $.getJSON('/cart.js').then(
      function(cart) {
		var hasSample = false;
        console.log(cart);
        //console.log(cart.item_count);

        var itemHTML = '';
        var items = [],
            item = {},
            data = {},
            source = $(".cart_drawer__items");
        $.each(cart.items, function(index, cartItem) {

          //console.log('cartItem_id:  '+cartItem.handle);
          var addedSlug = cartItem.handle;
          console.log('cart.items: '+ cart.items);

          //$('#slug-'+addedSlug).attr('data-hidden', 'false');
          $('#slug-'+addedSlug).addClass('addedCart');

          $( ".cart_drawer__recommended .cart_drawer__item" ).each(function( index ) {
            //console.log('SLUG: '+$(this).data('slug'));
            var eachSlug = $(this).data('slug');
            if(addedSlug == eachSlug){
              //console.log('in slug'+ $(this).data('hidden'));
              //$(this).attr('data-hidden', 'false');
              //$('#slug-'+eachSlug).attr('data-hidden', 'false');
            }else{
              //console.log('Out slug');
              //$(this).attr('data-hidden', 'true');
              //$(this).data('hidden', 'true');
              //$('#slug-'+addedSlug).attr('data-hidden', 'true');
            }
          });

          if (cartItem.image != null){
            var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '');
          } else {
            var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
          }

          for (var j = 0; j < cartItem.options_with_values.length; j++) {
            if(cartItem.options_with_values[j].name == 'Bag Size' ){
              var options_with_values = cartItem.options_with_values[j].value;
            }
          }

          console.log('getCartJSON: '+cartItem.properties);
          //shipping_interval_unit_type
          var shipping_interval_frequency,
              shipping_interval_unit_type,
              element = cartItem.properties;
          if (element != null) {
            shipping_interval_frequency = element.shipping_interval_frequency;
            var lb = Math.round(cartItem.grams * 0.00220462);
            if(lb == 3){
              var rprice = cartItem.price * 0.90;
            }

            if(lb == 7){
              var rprice = cartItem.price * 0.75;
            }
          }
          else {
            shipping_interval_frequency = null;
            shipping_interval_unit_type = null;
          }

          console.log(cartItem.properties);

          if(cartItem.properties != null || cartItem.properties != ''){
            var cartItem_properties = cartItem.properties;
          }else{
            var cartItem_properties = null;
          }

          console.log(cartItem.properties);

          item = {
            id: cartItem.id,
            key: cartItem.key,
            line: index + 1, // Shopify uses a 1+ index in the API
            url: cartItem.url,
            img: prodImg,
            name: cartItem.product_title,
            optionswithvalues: options_with_values,
            shippingintervalfrequency: shipping_interval_frequency,
            shippingintervalunittype: shipping_interval_unit_type,
            variation: cartItem.variant_title,
            properties: cartItem.properties,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            itemQty: cartItem.quantity,
            price: cartItem.price,
            rprice: rprice,
            product_has_only_default_variant : cartItem.product_has_only_default_variant,
            grams: cartItem.grams,
            vendor: cartItem.vendor,
            //linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
            linePrice: cartItem.line_price,
            originalLinePrice: cartItem.original_line_price,
            discounts: cartItem.discounts,
            discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
          };

          items.push(item);

          var handle = cartItem.handle;
          if(handle.includes("sampler")){
          	hasSample = true;
          }

        });

        for (var i = 0; i < cart.items.length; i++) {
          var lineHtml = "<div class='cart-popup-item cart_drawer__item added' data-addedfirstvid='"+ items[i].id +"' data-price="+items[i].price+" data-rprice="+items[i].rprice+" data-subscriptionsid='' data-addedqty='"+ items[i].itemQty +"' id='cover_"+ items[i].id +"' >";
          lineHtml += "<div class='item_img'><a href='"+ items[i].url +"'><img src='"+ items[i].img +"' alt='"+ items[i].img.alt +"' data-cart-item-image></a></div>";
          lineHtml += "<div class='item_name'>";
          lineHtml += "<h4 class='name'><a href="+ items[i].url +" class='cart__product-title' data-cart-item-title>"+items[i].name+"</a></h4>";
          if(items[i].product_has_only_default_variant){
            var lb = Math.round(items[i].grams * 0.00220462); //console.log("LB in CART : "+lb);
            lineHtml += "<span class='size'>"+ lb +"LB</span>";
          }
          if (typeof items[i].optionswithvalues != "undefined") {
            lineHtml += "<div class='cart-bag-size-wrap' data-cart-item-option>"+ items[i].optionswithvalues +"</div>";
          }
          lineHtml += "</div>";
          lineHtml += "<div class='item_add item__add_to_cart'>";
          lineHtml += "<div class='product__price' data-cart-item-line-price><div class="+ items[i].id +" data-cart-item-regular-price-group><span class='item__price' data-cart-item-regular-price>"+ theme.Currency.formatMoney(items[i].price*items[i].itemQty, theme.moneyFormat) +"</span></div></div>";
          lineHtml += "<div class='cart-quantity item_qty'>";
          lineHtml += "<span class='cartbtnqty qtyminus icon icon-minus' data-itemid="+ items[i].id +" field='updates_"+ items[i].key +"'>-</span>";
          lineHtml += "<input type='number' id='updates_"+ items[i].key +"' data-itemprice='"+ items[i].price +"' name='quantity' value='"+ items[i].itemQty +"' min='0' data-itemkey='"+ items[i].key +"' class='quantity-selector quantity-input-"+ items[i].id +" product-form__input product-form__input--quantity' data-quantity-input readonly=''>";
          lineHtml += "<span class='cartbtnqty qtyplus icon icon-plus' data-itemid="+ items[i].id +" field='updates_"+ items[i].key +"'>+</span>";
          lineHtml += "</div>";
          lineHtml += "</div>";

          lineHtml += "<button class='remove-item close-icon-wrap remove-item-"+ items[i].id +" hide'>";
          lineHtml += "<img data-id='"+ items[i].id +"' class='slide-remove-item' src='//cdn.shopify.com/s/files/1/1652/1243/files/Icon-Menu_small.png' alt='Close Icon'/>";
          lineHtml += "</button>";


          lineHtml += "<div class='subscription_cover'>";
          //lineHtml += "<input type='hidden' class='subscription_id' name='subscription_id' value='268814' />";
          //lineHtml += "<input type='hidden' class='shipping_interval_unit_type' name='shipping_interval_unit_type' value='"+items[i].shippingintervalunittype+"' />";
          //lineHtml += "<input type='hidden' class='shipping_interval_frequency' name='shipping_interval_frequency' value='"+items[i].shippingintervalfrequency+"' />";
          lineHtml += "</div>";


          lineHtml += "</div>";



          // Create HTML for each line item
          /*var lineHtml = "<div class='cart-popup-item' id='cover_"+ items[i].id +"' >";
            	lineHtml += "<div class='cart__image-wrapper'><a href='"+ items[i].url +"'><a href='"+ items[i].url +"'><img class='cart__image' src='"+ items[i].img +"' alt='"+ items[i].img.alt +"' data-cart-item-image></a></div>";
            	lineHtml += "<div class='cart-popup-item__description'>";
            	lineHtml += "<div class='list-view-item__title cart-popup-item__title'><a href="+ items[i].url +" class='cart__product-title' data-cart-item-title>"+items[i].name+"</a></div>";

            	lineHtml += "<div class='cart-bag-price-wrap'>";


                if(items[i].product_has_only_default_variant){
                  	var lb = Math.round(items[i].grams * 0.00220462); console.log("LB in CART : "+lb);
            		lineHtml += "<div class='cart-bag-size-wrap' data-cart-item-option>"+ lb +"LB</div>";
                }


            	if (typeof items[i].optionswithvalues != "undefined") {
            	lineHtml += "<div class='cart-bag-size-wrap' data-cart-item-option>"+ items[i].optionswithvalues +"</div>";
                }
            	lineHtml += "<div class='cart-price-wrap'><div class='product__price' data-cart-item-line-price><div class="+ items[i].id +" data-cart-item-regular-price-group><span data-cart-item-regular-price>"+ theme.Currency.formatMoney(items[i].price*items[i].itemQty, theme.moneyFormat) +"</span></div></div></div>";
            	lineHtml += "</div>";

            	lineHtml += "<div class='cart-quantity'>";
            	lineHtml += "<span class='cartbtnqty qtyminus icon icon-minus' data-itemid="+ items[i].id +" field='updates_"+ items[i].key +"'>-</span>";
            	lineHtml += "<input type='number' id='updates_"+ items[i].key +"' data-itemprice='"+ items[i].price +"' name='quantity' value='"+ items[i].itemQty +"' min='1' data-itemkey='"+ items[i].key +"' class='quantity-selector quantity-input-"+ items[i].id +" product-form__input product-form__input--quantity' data-quantity-input readonly=''>";
            	lineHtml += "<span class='cartbtnqty qtyplus icon icon-plus' data-itemid="+ items[i].id +" field='updates_"+ items[i].key +"'>+</span>";
            	lineHtml += "</div>";
            	if (items[i].shippingintervalfrequency != null || items[i].shippingintervalunittype != null) {
            	lineHtml += "<div class='week-wrap'>EVERY "+ items[i].shippingintervalfrequency +" "+ items[i].shippingintervalunittype +"</div>";
                }

            	lineHtml += "<button class='remove-item close-icon-wrap remove-item-"+ items[i].id +"'>";
            	lineHtml += "<img data-id='"+ items[i].id +"' class='slide-remove-item' src='//cdn.shopify.com/s/files/1/1652/1243/files/Icon-Menu_small.png' alt='Close Icon'/>";
            	lineHtml += "</button>";

            	lineHtml += "</div>";
            	lineHtml += "</div>";*/


          // Joining each line HTML
          itemHTML += lineHtml;
        }

        source.html(itemHTML);


        var count = cart.item_count;
        if(hasSample == true){
        	count = 3;
        }



        if(count >= 1){
          $('.cart_drawer__footer').removeClass('hide');
        }

        $('#CartCount span[data-cart-count]').text(cart.item_count);
        var CartTotalPrice = theme.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        $('.subtotal-price-wrap').text(CartTotalPrice + ' USD');


        if(count == 1){ console.log('loop 1');
          $('.progress').html('<span style="width: 33%;"></span>');
          $('.cart_drawer__process p:nth-child(1)').text('Add 1 Item to Ship Your Order');
          $('.cart_drawer__process p:nth-child(1)').removeClass('hide');
          $('.cart_drawer__process p:nth-child(2)').addClass('hide');
          $('#ajax_checkout').addClass('disabled');
          $('.shipping-tag').text('$15.00');
		  $('.cart_drawer__process').removeClass('finished');
		  $('.cart_drawer__recommended').removeClass('hide');
        }else if(count == 2){ console.log('loop 2');
          $('.progress').html('<span style="width: 66%;"></span>');
          $('.cart_drawer__process p:nth-child(1)').html('<a href="javascript:;" class="ajax_checkout_2">Checkout</a> or Add 1 Item for Free Shipping');
          $('.cart_drawer__process p:nth-child(1)').removeClass('hide');
          $('.cart_drawer__process p:nth-child(2)').addClass('hide');
          $('#ajax_checkout').removeClass('disabled');
          $('.shipping-tag').text('$15.00');
		  $('.cart_drawer__process').removeClass('finished');
		  $('.cart_drawer__recommended').removeClass('hide');
        }else if(count >= 3){ console.log('loop 3');
          $('.progress').html('<span style="width: 100%;"></span>');
          $('.cart_drawer__process p:nth-child(1)').addClass('hide');
          $('.cart_drawer__process p:nth-child(2)').removeClass('hide');
          $('#ajax_checkout').removeClass('disabled');
		  $('.cart_drawer__process').addClass('finished');
          $('.shipping-tag').text('FREE');
		  $('.cart_drawer__recommended').addClass('hide');
        }else{ console.log('Else loop');
          $('.cart_drawer__process p:nth-child(1)').addClass('hide');
          $('.cart_drawer__process p:nth-child(2)').addClass('hide');
        }




      })


    setTimeout(function(){ $('.loader-cover').addClass('hide'); }, 2000);
    $('.subscription__cover').removeClass('hide');
  }

  function addAllSample(){

  }


  function cartHiddenSlug(){

    $.getJSON('/cart.js').then(function(cart) { console.log('In console loop');

	  cartDrawerProcess(cart, cart.item_count);
      if(cart.item_count == 0 ){ $('.cart_drawer__footer').addClass('hide');    }
	  $( ".cart_drawer__recommended .cart_drawer__item").attr('data-hidden', 'true');
	  var size_selected = $( ".cart_drawer__items .cart_drawer__item:first-child .size" ).text();
	  var trimSizeSelected = $.trim(size_selected);

      $.each(cart.items, function(index, cartItem) {

        console.log('In console second loop');

        for (var i = 0; i < cart.items.length; i++) {
          var lb = Math.round(cartItem.grams * 0.00220462);
        }


        if (JSON.stringify(trimSizeSelected).indexOf("3lb") > -1) {
          $( ".cart_drawer__recommended .cart_drawer__item.7lb" ).attr('data-hidden', 'false');
        }
        if (JSON.stringify(trimSizeSelected).indexOf("3LB") > -1) {
          $( ".cart_drawer__recommended .cart_drawer__item.7lb" ).attr('data-hidden', 'false');
        }
        if (JSON.stringify(trimSizeSelected).indexOf("7lb") > -1) {
		  $( ".cart_drawer__recommended .cart_drawer__item.7lb" ).removeClass('hide');
          $( ".cart_drawer__recommended .cart_drawer__item.3lb" ).attr('data-hidden', 'false');
        }
        if (JSON.stringify(trimSizeSelected).indexOf("7LB") > -1) {
		  $( ".cart_drawer__recommended .cart_drawer__item.7lb" ).removeClass('hide');
          $( ".cart_drawer__recommended .cart_drawer__item.3lb" ).attr('data-hidden', 'false');
        }


        console.log('cartItem_id:  '+cartItem.handle);
        var addedSlug = cartItem.handle;

        //$('#slug-'+addedSlug).attr('data-hidden', 'false');
        $('#slug-'+addedSlug).addClass('addedCart');
        $( ".cart_drawer__recommended .cart_drawer__item:not(.item_sample)" ).each(function( index ) {
          var allSlug = $(this).data('slug'); console.log('all : '+allSlug +"-"+ addedSlug.search(allSlug));
          if( addedSlug.search(allSlug) > -1 ){
            $( ".cart_drawer__recommended [data-slug='"+allSlug+"']" ).attr('data-hidden', 'false');
            $( "#slug-"+allSlug ).attr('data-hidden', 'false');
          }

        });

        //$( ".cart_drawer__recommended [data-slug='"+addedSlug+"']" ).attr('data-hidden', 'false');
        //$( "#slug-"+addedSlug ).attr('data-hidden', 'false');
		setTimeout(function(){ $('.loader-cover').addClass('hide'); }, 2000);

      });

    });

  }

  function cartPriceUpdate(){

    setTimeout(function(){


      var onetimePrice = 0;
      var RecurringPrice = 0;

      $(".cart_drawer__items .cart_drawer__item.added").each(function(){

        var qty = $(this).attr('data-addedqty');
        var price = $(this).attr('data-price');
        var rprice = $(this).attr('data-rprice');

        onetimePrice = onetimePrice + (qty*price);
        RecurringPrice = RecurringPrice + (qty*rprice);

      })

      $("#one-time-price_cart").text(window.Spruce.store('state').centsToDollars(window.Spruce.store('state').cart.total_amount));
      $("#recurring-time-price_cart").text(window.Spruce.store('state').subscriptionTotal(window.Spruce.store('state').cart.total_amount));

      if($("#one-time-price_cart").parents(".cart_recharge").hasClass("selected")){
      	$("[data-cart-subtotal]").text(window.Spruce.store('state').centsToDollars(window.Spruce.store('state').cart.total_amount));
      }

      if($("#recurring-time-price_cart").parents(".cart_recharge").hasClass("selected")){
      	$("[data-cart-subtotal]").text(window.Spruce.store('state').subscriptionTotal(window.Spruce.store('state').cart.total_amount));
      }


      /*

      var size_selected = $( ".cart_drawer__items .cart_drawer__item:first-child .size" ).text();
      var trimSizeSelected = $.trim(size_selected);
      var cart_total_qty = $('[data-cart-count]').text();

      var three_lb__price = '34.99';
      var three_lb__discount_price = '31.99';
      var threeLBFinal = three_lb__price * cart_total_qty;
      var threeLBFinalDiscount = three_lb__discount_price * cart_total_qty;

      var seven_lb__price = '69.99';
      var seven_lb__discount_price = '52.49';
      var SevenLBFinal = seven_lb__price * cart_total_qty;
      var SevenLBFinalDiscount = seven_lb__discount_price * cart_total_qty;

      console.log(cart_total_qty);

      if (JSON.stringify(trimSizeSelected).indexOf("3lb") > -1) {  console.log('3LB size_selected');
        $('#one-time-price_cart').text('$'+ threeLBFinal.toFixed(2)+' USD');
        $('#recurring-time-price_cart').text('$'+ threeLBFinalDiscount.toFixed(2)+' USD');
      }
      if (JSON.stringify(trimSizeSelected).indexOf("3LB") > -1) { console.log('3LB size_selected');
        $('#one-time-price_cart').text('$'+ threeLBFinal.toFixed(2)+' USD');
        $('#recurring-time-price_cart').text('$'+ threeLBFinalDiscount.toFixed(2)+' USD');
      }

      if (JSON.stringify(trimSizeSelected).indexOf("7lb") > -1) { console.log('7LB size_selected');
        $('#one-time-price_cart').text('$'+ SevenLBFinal.toFixed(2)+' USD');
        $('#recurring-time-price_cart').text('$'+ SevenLBFinalDiscount.toFixed(2)+' USD');
		$('.rc_discount_percentage').text('EXTRA 25 %');
      }
      if (JSON.stringify(trimSizeSelected).indexOf("7LB") > -1) { console.log('7LB size_selected');
        $('#one-time-price_cart').text('$'+ SevenLBFinal.toFixed(2)+' USD');
        $('#recurring-time-price_cart').text('$'+ SevenLBFinalDiscount.toFixed(2)+' USD');
		$('.rc_discount_percentage').text('EXTRA 25 %');
      }
      */

    }, 2000);

  }



  $(".cart_recharge").click(function(){
  	 console.log('clicked on option');
    //cartPriceUpdate();
      if($("#one-time-price_cart").parents(".cart_recharge").hasClass("selected")){
      	$("[data-cart-subtotal]").text($("#one-time-price_cart").text());
      }

      if($("#recurring-time-price_cart").parents(".cart_recharge").hasClass("selected")){
      	$("[data-cart-subtotal]").text($("#recurring-time-price_cart").text());
      }

  })



});


page = {
  EqualHeight: function(a){
    var top = 0;
    var main = $(a);
    var randomClass = ( 'eH' + Math.random() ).replace('.','');
    // console.log('A random class: ' + randomClass); // ?
    main.each( function() {

      var distanceFromTop = $(this).offset().top;
      // console.log('This is ' + distanceFromTop + ' from the top.');

      if ( distanceFromTop > top ) {
        $('.' + randomClass).removeClass(randomClass);
        top = distanceFromTop;
        // console.log('"top" is ' + top + 'px away');
      }

      $(this).addClass(randomClass);

      $(this).css('min-height','auto');

      var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
        return $(this).outerHeight();
      }).get()));

      $('.' + randomClass).css('min-height',newHeight);

    }).removeClass(randomClass);

  },
  EqualHeight2: function(a){
    var maxHeight = 0;
    var main = $(a);
    main.each( function() {
      $(this).css('min-height','auto');

      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    main.each( function() {
      $(this).css('min-height', maxHeight);
    });
  },


  Popup:function(){
    var main = $('.popup_section');
    var section = $('#PageContainer');
    var close = $('.popup_close');
    var h = main.outerHeight();
    section.css('padding-bottom', h);

    close.click(function() {
      main.css('bottom', -h - 80);
      section.css('padding-bottom', 0);
    });

    $( window ).resize(function () {
      var main = $('.popup_section');
      var section = $('#PageContainer');

      var h = main.outerHeight();
      section.css('padding-bottom', h);
    });

  },

  PressLogo: function(){
    $('.text-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay: true,
      asNavFor: '.img-slide'
    });
    $('.img-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.text-slide',
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true
    });
    $('.js-logo-bar-slider:not(".slick-initialized")').each(function(){
        $(this).slick({
            slidesToShow: $(this).data('count'),
            slidesToScroll: $(this).data('count'),
            dots: true,
            arrows: false, autoplay: false,
            infinite: false,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: $(this).data('count')>3?3:$(this).data('count'),
                    slidesToScroll: $(this).data('count')>3?3:$(this).data('count'),
                  }
                },
                {
                  breakpoint: 749,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            });
        })
  },
  Instagram: function(){
    var a = $('.instagram-slider');

    $('.instagram_section .slick-prev').click(function(){
      a.slick('slickPrev');
    });

    $('.instagram_section .slick-next').click(function(e){
      e.preventDefault();
      a.slick('slickNext');
    });

    if(a.attr('data-count') > 3){
      if($(window).width() > 990 ){
        a.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots:false
        });
      }
      else if($(window).width() > 749){
        a.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots:false
        });
      }
      else{
        a.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots:false
        });
      }
    }
    else{
      if($(window).width() < 750){
        a.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots:false
        });
      }
    }
  },

  CollectionList:function(){
    var a = $('.collection_list_section .product__grid').attr('data-slide');

    if($('.collection_list_section .product__grid').length){
      if($(window).width() < 750 && a == "true"){

        $('.collection_list_section .product__grid').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots:false,
          infinite: true,
          centerMode: true,
          centerPadding: '40px',
          variableWidth: false
        });

      }
    }

    var _window = $(window),
        window_width = _window.width(),
        window_height = _window.height();


    function cereal_plot_init(){
     // console.log('img');
      var plot = $(this),
          cereal = plot.find('img');

      plot.each(function(){
        var _this = $(this);
        _this.data('top',Math.floor(_this.offset().top));
      }).show();

      cereal.each(function(){
        $(this).attr('data-multiply',Math.floor(Math.random()*2) + 1)
      });

      function plot_mousemove(e){
        var x = Math.floor((e.screenX - ((e.screenX > window_width/2)
                                         ? window_width/2
                                         : window_width/2 - plot.offset().left)
                           )*.1),
            y = Math.floor((e.screenY - window_height/2)*.1)

        cereal.each(function(i){
          let _this = $(this);
          let m = _this.data('multiply');

          _this.css({
            '-webkit-transform': `translate(calc(-50% + ${x}px),calc(-50% + ${y}px))`,
            'transform': `translate(calc(-50% + ${x}px),calc(-50% + ${y}px))`
          })
          /*_this.css({
				'-webkit-transform': `translateY(calc(-50% + ${y}px))`,
				'transform': `translateY(calc(-50% + ${y}px))`
			})*/
        })
      }
      _window.on('mousemove',plot_mousemove);
    }

    //$('.img-dec_wrap').each(cereal_plot_init);


  },

  Blog:function(){
    if ($(window).width() < 1024 && $(window).width() >= 768) {
      $('.blog-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        infinite: true,
        centerMode: false,
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev" viewBox="0 0 21 21"><path fill="#0C3D37" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
    	nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next" viewBox="0 0 21 21"><path fill="#0C3D37" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>'
      });
    }
    if($(window).width() < 767){
      $('.blog-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        infinite: true,
        centerMode: false,
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev" viewBox="0 0 21 21"><path fill="#0C3D37" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
    	nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next" viewBox="0 0 21 21"><path fill="#0C3D37" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>'
      });
    }
  },

  Gallery:function(){
    if($(window).width() < 767){
      $('.images-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots:false,
        infinite: true,
        centerMode: true,
        centerPadding: '0px'
      });
    }
  },

  Quote:function(){
    if($(".testimonial_slider").length){
    if($(window).width() <= 767){
      $('.testimonial_slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev" viewBox="0 0 21 21"><path fill="#0C3D37" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
    	nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next" viewBox="0 0 21 21"><path fill="#0C3D37" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>'
      });
    }
     else if ($(window).width() < 1024 && $(window).width() >= 768) {
       $('.testimonial_slider').not('.slick-initialized').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        infinite: true,
        centerMode: true,
        variableWidth: true,
         centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev" viewBox="0 0 21 21"><path fill="#0C3D37" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
    	nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next" viewBox="0 0 21 21"><path fill="#0C3D37" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>'
      });
     }
    else{
      $('.testimonial_slider').not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        centerPadding: '0px',
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev" viewBox="0 0 21 21"><path fill="#0C3D37" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
    	nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next" viewBox="0 0 21 21"><path fill="#0C3D37" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>'
      });
    }
    }
  },

  BlogBanner:function(){
    $('.blog-banner-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots:false,
      infinite: true,
      centerMode: false
    });
  },

  Product: function(){

    // product_whats_inside
    var $cog = $('.product_whats_inside .bowl_img')
        $(window).scroll(function() {
          var theta = $(window).scrollTop() / 10;
          $cog.css({ transform: 'rotate(' + theta + 'deg)' });
        });

        $('.product-single__media-slider').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          slide: '.product-single__media-wrapper',
          arrows: true,
          dots:false,
          infinite: true,
          centerMode: false,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          asNavFor: '.thumbnails-wrapper__desktop .product-single__thumbnails',
          prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev icon--full-color" viewBox="0 0 21 21"><path fill="#fff" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
          nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next icon--full-color" viewBox="0 0 21 21"><path fill="#fff" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>',
          responsive: [
            {
              breakpoint: 750,
              settings: {
                dots: false
              }
            }
          ]
        });

        $('.thumbnails-wrapper__desktop .product-single__thumbnails').slick({
          slidesToShow: 5,
          swipeToSlide: true,
          infinite: false,
          arrows: false,
          asNavFor: '.product-single__media-slider',
          focusOnSelect: true,
        });

        $('.thumbnails-wrapper__mobile .product-single__thumbnails').not('.slick-initialized').slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev icon--full-color" viewBox="0 0 21 21"><path fill="#fff" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
          nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next icon--full-color" viewBox="0 0 21 21"><path fill="#fff" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>'
        });


    // Product Ingredients
    var nutrient_pop_up = $('#mobile-nutrient-pop-up'),
        nutrient_pop_up_content = nutrient_pop_up.find('#nutrient-pop-up-content'),
        nutrient_pop_up_close = nutrient_pop_up.find('.popup_close');

    $(document).on('mousemove', '.nutrients li.content', function(e){
      $(this).addClass('active').find('.nutrient-pop-up')
      /*.css({
        'top':`${e.clientY}px`,
        'left':`${e.clientX}px`
      })*/
    }).on('mouseleave', '.nutrients li.content', function(){
      $(this).removeClass('active')
    });

    if($(window).width() < 750){
      $('.nutrients li.content').click(function(){
        var _this = $(this);

        if(_this.find('.nutrient-pop-up').length){
          nutrient_pop_up_content.html(_this.find('.nutrient-pop-up').html());
          $('html').addClass('nutrient_pop_up_active');
        }
      });
    }
    nutrient_pop_up_close.click(function(){
      console.log('working');
      $('html').removeClass('nutrient_pop_up_active');
      nutrient_pop_up_content.empty();
    });

    /// Nutrients Slider
    const initNutrientsSlider = () => {
      $('[data-nutrients-slider]').not('.slick-initialized').each((i, nutrientsSlider) => {
        $(nutrientsSlider).slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: true,
            centerMode: false,
            draggable: false,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev icon--full-color" width="15" height="24" viewBox="0 0 15 24" fill="none"><path d="M13 22.0002L3 12.0002L13 2.00025" stroke="#0C3D37" stroke-width="3"/></svg></button>',
            nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-prev icon--full-color" width="15" height="24" viewBox="0 0 15 24" fill="none"><path d="M2 2.00024L12 12.0002L2 22.0002" stroke="#0C3D37" stroke-width="3"/></svg></button>',
            appendArrows: $(nutrientsSlider),
            appendDots: $(nutrientsSlider),
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  appendArrows: $(nutrientsSlider).siblings('[data-nutrients-slick-controls-wrap]'),
                  appendDots: $(nutrientsSlider).siblings('[data-nutrients-slick-controls-wrap]'),
                  adaptiveHeight: false,
                }
              }
            ]
        });
      });
    }
    initNutrientsSlider();

    $(window).resize(() => {
      initNutrientsSlider();
    });

    const arrowTopPosition = ($('.nutrients__image').height() / 2) + 20;
    const dotsTopPosition = $('.nutrients__image').height() + 40;
    $('[data-nutrients-slider] .slick-arrow').css('top', `${arrowTopPosition}px`)
    $('[data-nutrients-slider] .slick-dots').css('top', `${dotsTopPosition}px`)

    /// Custom Banner Images
    if($(window).width() >= 768){
      var $v = $('.banner_custom_section .hero__images .hero_img-1'),
          $v1 = $('.banner_custom_section .hero__images .hero_img-2'),
          $v2 = $('.banner_custom_section .hero__images .hero_img-3');
      $(window).scroll(function() {
        var theta = $(window).scrollTop() / 8;
        if($(window).width() < 1025){
          if(theta > 150){
            theta = 150;
          }
          else{
            theta = theta;
          }
        }
        else{
          if(theta > 380){
            theta = 380;
          }
          else{
            theta = theta;
          }
        }
        $v.css({ transform: 'translateX(' + theta + 'px)' });
        $v1.css({ transform: 'translateX(' + -theta + 'px)' });
        $v2.css({ transform: 'translateX(' + -theta + 'px)' });
      });
    }

    if ($('header').hasClass('header--transparent')) {
      $('#shopify-section-product-template .product-template__color').addClass('product-template__color--transparent-header');
    }

    // Dynamic card color based on background: changes card color to alt color if background matches primary color
    if ($('.template-multipack-dry').length || $('.template-bundle-builder').length) {
      const backgroundColor = $('#shopify-section-reviews-ugc').css('background-color');
      $('.reviews-ugc__item--review').each((i, card) => {
        const cardColor = $(card).css('background-color')
        const altCardColor = $(card).attr('data-alt-bg-color');
        if (cardColor == backgroundColor) $(card).css('background-color', altCardColor);
      })
    }
  },
  ReviewsUGC: function () {
    if ($('.js-reviews-ugc-slider').length > 0) {
      $('.js-reviews-ugc-slider').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="28.5" transform="rotate(-180 30 30)" stroke="#0C3D37" stroke-width="3"/><path d="M35 40L25 30L35 20" stroke="#0C3D37" stroke-width="3"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="28.5" stroke="#0C3D37" stroke-width="3"/><path d="M25 20L35 30L25 40" stroke="#0C3D37" stroke-width="3"/></svg></button>'
      });
    }
  }
}

var accordion = (function(){

  var $accordion = $('.js-accordion');
  var $accordion_header = $accordion.find('.js-accordion-header');
  var $accordion_item = $('.js-accordion-item');

  // default settings
  var settings = {
    // animation speed
    speed: 400,

    // close all other accordion items if true
    oneOpen: false
  };

  return {
    // pass configurable object literal
    init: function($settings) {
      $accordion_header.on('click', function() {
        accordion.toggle($(this));
      });

      $.extend(settings, $settings);

      // ensure only one accordion is active if oneOpen is true
      if(settings.oneOpen && $('.js-accordion-item.active').length > 1) {
        $('.js-accordion-item.active:not(:first)').removeClass('active');
      }

      // reveal the active accordion bodies
      $('.js-accordion-item.active').find('> .js-accordion-body').show();
    },
    toggle: function($this) {

      if(settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
        $this.closest('.js-accordion')
               .find('> .js-accordion-item')
               .removeClass('active')
               .find('.js-accordion-body')
               .slideUp()
      }

      // show/hide the clicked accordion item
      $this.closest('.js-accordion-item').toggleClass('active');
      $this.next().stop().slideToggle(settings.speed);
    }
  }
})();



$(function (){
  'use strict';
  page.PressLogo();
  page.Popup();
  page.Instagram();
  page.CollectionList();
  page.Blog();
  page.Gallery();
  page.Quote();
  page.BlogBanner();
  page.Popup();
  page.Product();
  page.ReviewsUGC();
  page.EqualHeight('.press_logo_section .logo-bar__text p');
  page.EqualHeight('.press-logo-section--homepage .logo-bar__image-wrapper');
  page.EqualHeight('.collection_list_section .product-card__title');
  page.EqualHeight('.collection_list_section .price--listing');
  page.EqualHeight2('.product_whats_inside .content li');
  setTimeout(function(){
  page.EqualHeight('.collection_list_section .product-card__image-wrapper');
   },1000);
  //accordion.init({ speed: 300, oneOpen: true });
  
  $('body').on('click', '.js-accordion .js-accordion-header', function (e) {
    const $accordion_header = $(this);
    const $accordion_item = $accordion_header.closest('.js-accordion-item');
    const $accordion = $accordion_header.closest('.js-accordion');
    const speed = 300;
    const oneOpen = true;

    if (oneOpen) {
      $accordion.find('.js-accordion-item').not($accordion_item).each((index, accordionEl) => {
        $(accordionEl).removeClass('active').find('.js-accordion-body').slideUp();
      });
    }

    $accordion_item.toggleClass('active');
    $accordion_header.next().stop().slideToggle(speed);
  });




  setTimeout(function(){
     console.log('Animation');
    AOS.init();
  },1000);

  var $img = $('.js-image-rotate');
  if($img.length>0) {
    $(window).scroll(function () {
      var theta = $(window).scrollTop() / 10;
      $img.css({transform: 'rotate(' + theta + 'deg)'});
    });
  }

  /* Category toggle section */
  $('body').on('click', '.js-category-toggle-btn', function (e) {
    e.preventDefault();
    var el = $('.js-category-toggle-item[data-name="' + $(this).data('name') + '"]');
    if (el.length > 0) {
      var parent = el.parents('.js-category-toggle-items');
      parent.find('.js-category-toggle-item.is-active').removeClass('is-active');
      el.addClass('is-active');
    }
  });
});


$( window ).resize(function () {
  page.PressLogo();
  page.Instagram();
  page.CollectionList();
  page.Blog();
  page.Gallery();
  page.Quote();
  page.BlogBanner();
  page.Product();
  page.EqualHeight('.press_logo_section .logo-bar__text p');
  page.EqualHeight('.collection_list_section .product-card__title');
  page.EqualHeight('.press-logo-section--homepage .logo-bar__image-wrapper');
  page.EqualHeight('.collection_list_section .price--listing');
  page.EqualHeight('.product_whats_inside .content li');
  setTimeout(function(){
  page.EqualHeight('.collection_list_section .product-card__image-wrapper');
   },1000);
  //check_addtocart();
});



// Range  ===============

function init() {
    const sliders = document.getElementsByClassName("tick-slider-input");

    for (let slider of sliders) {
        slider.oninput = onSliderInput;

        updateValue(slider);
        updateValuePosition(slider);
        updateLabels(slider);
        updateProgress(slider);

        setTicks(slider);
    }
}

function onSliderInput(event) {
    updateValue(event.target);
    updateValuePosition(event.target);
    updateLabels(event.target);
    updateProgress(event.target);
}

function updateValue(slider) {

  	var weight = [5,10,15,20,40,60,80,100]
  	console.log("value : "+slider.value);


    let value = document.getElementById(slider.dataset.valueId);
    let text = document.getElementById(slider.dataset.textId);

    value.innerHTML = "<span>" + weight[slider.value - 1] + " LBS</span>";
    if(slider.value <= 3){
      text.innerHTML = "<span>Small</span>";
    }else if(slider.value > 6){
      text.innerHTML = "<span>Large</span>";
    }else{
      text.innerHTML = "<span>Medium</span>";
    }
}

function updateValuePosition(slider) {
    let value = document.getElementById(slider.dataset.valueId);
    let text = document.getElementById(slider.dataset.textId);

    const percent = getSliderPercent(slider);

    const sliderWidth = slider.getBoundingClientRect().width;
    const valueWidth = value.getBoundingClientRect().width;
    const textWidth = value.getBoundingClientRect().width;
    const handleSize = slider.dataset.handleSize;

    let left = percent * (sliderWidth - handleSize) + handleSize / 2 - valueWidth / 2;
  	let text_left = percent * (sliderWidth - handleSize) + handleSize / 2 - textWidth / 2;

    left = Math.min(left, sliderWidth - valueWidth);
    left = slider.value === slider.min ? 0 : left;

  	text_left = Math.min(left, sliderWidth - textWidth);
    text_left = slider.text === slider.min ? 0 : text_left;

    value.style.left = left + "px";
    text.style.left = text_left + "px";
}

function updateLabels(slider) {
    const value = document.getElementById(slider.dataset.valueId);
    const text = document.getElementById(slider.dataset.textId);

    const minLabel = document.getElementById(slider.dataset.minLabelId);
    const maxLabel = document.getElementById(slider.dataset.maxLabelId);

    const valueRect = value.getBoundingClientRect();
    const minLabelRect = minLabel.getBoundingClientRect();
    const maxLabelRect = maxLabel.getBoundingClientRect();

    const minLabelDelta = valueRect.left - (minLabelRect.left);
    const maxLabelDelta = maxLabelRect.left - valueRect.left;

    const deltaThreshold = 32;

    if (minLabelDelta < deltaThreshold) minLabel.classList.add("hidden");
    else minLabel.classList.remove("hidden");

    if (maxLabelDelta < deltaThreshold) maxLabel.classList.add("hidden");
    else maxLabel.classList.remove("hidden");
}

function updateProgress(slider) {
    let progress = document.getElementById(slider.dataset.progressId);
    const percent = getSliderPercent(slider);

    progress.style.width = percent * 100 + "%";
}

function getSliderPercent(slider) {
    const range = slider.max - slider.min;
    const absValue = slider.value - slider.min;

    return absValue / range;
}

function setTicks(slider) {
    let container = document.getElementById(slider.dataset.tickId);
    const spacing = parseFloat(slider.dataset.tickStep);
    const sliderRange = slider.max - slider.min;
    const tickCount = sliderRange / spacing + 1; // +1 to account for 0

    for (let ii = 0; ii < tickCount; ii++) {
        let tick = document.createElement("span");

        tick.className = "tick-slider-tick";

        container.appendChild(tick);
    }
}

function onResize() {
    const sliders = document.getElementsByClassName("input_output");

    for (let slider of sliders) {
        updateValuePosition(slider);
    }
}

function addItemToCart(variant_id, qty, sellingplan) {
  console.log("ID : "+variant_id);
  console.log("QTY : "+qty);
  console.log("FREQ : "+sellingplan);

    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": sellingplan
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(item) {
        $.getJSON('/cart.js').then(
          function(cart) {
            console.log(cart);
        });
        console.log("Success"+JSON.stringify(item));
        let product = new theme.Product();
        product._setupCartPopup(item);
        //window.location.href = '/cart';

      }
    });
    //window.location = '/checkout';
  }


function check_addtocart(){ console.log("IN FUNCTION");

  if($(window).width() < 750){

    $(".product-form").addClass("unclicked");
    $("[data-add-to-cart]").addClass("firstclick");

  }else{

    $(".product-form").removeClass("unclicked");
    $("[data-add-to-cart]").removeClass("firstclick");

  }



}




window.onload = init;
window.addEventListener("resize", onResize);
